var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsSolution2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0832 41.6963L21.8517 46.1843C23.2457 46.9897 24.9636 46.9897 26.3576 46.1843L34.1261 41.6963C35.2001 41.0758 35.8617 39.9296 35.8617 38.6892V26.6899L35.684 26.8942C35.3151 27.318 34.8786 27.6778 34.3921 27.9589Lnan nanL34.3921 27.9589L32.9224 28.8079L29.9832 30.506L26.0358 32.7865C24.8409 33.4768 23.3684 33.4768 22.1736 32.7865L18.2262 30.506L15.2869 28.8079L13.8173 27.9589Lnan nanL13.8173 27.9589C13.3307 27.6778 12.8939 27.3183 12.5245 26.895L12.3477 26.6924L12.3477 38.6892C12.3477 39.9296 13.0092 41.0758 14.0832 41.6963Z",
    fill: "url(#paint0_linear_2137_19306)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0348 33.0268C24.84 33.717 23.3676 33.717 22.1727 33.0267L12.9634 27.7063C12.106 27.2109 12.106 25.9732 12.9634 25.4778L22.1725 20.1575C23.3675 19.4672 24.84 19.4672 26.0349 20.1576L35.2442 25.4786C36.1016 25.974 36.1015 27.2117 35.244 27.707L26.0348 33.0268Z",
    fill: "url(#paint1_linear_2137_19306)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5754 41.3472L53.3439 45.8352C54.7379 46.6406 56.4558 46.6406 57.8498 45.8352L65.6183 41.3472C66.6923 40.7267 67.3539 39.5805 67.3539 38.3401V26.3408L67.1761 26.5451C66.8073 26.9689 66.3708 27.3287 65.8842 27.6097Lnan nanL65.8842 27.6097L64.4146 28.4588L61.4754 30.1568L57.528 32.4373C56.3331 33.1276 54.8606 33.1276 53.6657 32.4373L49.7184 30.1568L46.7791 28.4588L45.3095 27.6097Lnan nanL45.3095 27.6097C44.8229 27.3287 44.3861 26.9692 44.0167 26.5458L43.8398 26.3432L43.8398 38.3401C43.8398 39.5805 44.5014 40.7267 45.5754 41.3472Z",
    fill: "url(#paint2_linear_2137_19306)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.527 32.6777C56.3321 33.3679 54.8597 33.3679 53.6649 32.6776L44.4556 27.3571C43.5981 26.8618 43.5981 25.6241 44.4556 25.1287L53.6647 19.8084C54.8596 19.1181 56.3322 19.1181 57.5271 19.8085L66.7363 25.1295C67.5938 25.6249 67.5937 26.8626 66.7362 27.3579L57.527 32.6777Z",
    fill: "url(#paint3_linear_2137_19306)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0168 50.1426L37.7853 54.6306C39.1793 55.436 40.8972 55.436 42.2912 54.6306L50.0597 50.1426C51.1337 49.5221 51.7953 48.3759 51.7953 47.1355V35.1362L51.6175 35.3405C51.2487 35.7643 50.8122 36.1241 50.3256 36.4052Lnan nanL50.3256 36.4052L48.856 37.2542L45.9168 38.9523L41.9694 41.2328C40.7745 41.9231 39.302 41.9231 38.1072 41.2328L34.1598 38.9523L31.2205 37.2542L29.7509 36.4052Lnan nanL29.7509 36.4052C29.2643 36.1241 28.8275 35.7646 28.4581 35.3413L28.2812 35.1387L28.2813 47.1355C28.2813 48.3759 28.9428 49.5221 30.0168 50.1426Z",
    fill: "url(#paint4_linear_2137_19306)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9684 41.4731C40.7735 42.1633 39.3012 42.1633 38.1063 41.473L28.897 36.1526C28.0395 35.6572 28.0395 34.4195 28.897 33.9241L38.1061 28.6038C39.3011 27.9135 40.7736 27.9135 41.9685 28.6039L51.1778 33.9249C52.0352 34.4203 52.0351 35.658 51.1776 36.1533L41.9684 41.4731Z",
    fill: "#D9EFFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0168 34.3955L37.7853 38.8835C39.1793 39.6889 40.8972 39.6889 42.2912 38.8835L50.0597 34.3955C51.1337 33.775 51.7953 32.6288 51.7953 31.3884V19.3892L51.6175 19.5934C51.2487 20.0172 50.8122 20.377 50.3256 20.6581Lnan nanL50.3256 20.6581L48.856 21.5071L45.9168 23.2052L41.9694 25.4857C40.7745 26.176 39.302 26.176 38.1072 25.4857L34.1598 23.2052L31.2205 21.5071L29.7509 20.6581Lnan nanL29.7509 20.6581C29.2643 20.377 28.8275 20.0175 28.4581 19.5942L28.2812 19.3916L28.2813 31.3884C28.2813 32.6288 28.9428 33.775 30.0168 34.3955Z",
    fill: "url(#paint5_linear_2137_19306)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9684 25.726C40.7735 26.4162 39.3012 26.4162 38.1063 25.7259L28.897 20.4055C28.0395 19.9101 28.0395 18.6724 28.897 18.1771L38.1061 12.8568C39.3011 12.1664 40.7736 12.1665 41.9685 12.8568L51.1778 18.1778C52.0352 18.6732 52.0351 19.9109 51.1776 20.4062L41.9684 25.726Z",
    fill: "url(#paint6_linear_2137_19306)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5696 58.9693L52.338 63.4573C53.7321 64.2626 55.4499 64.2626 56.844 63.4573L64.6124 58.9693C65.6865 58.3488 66.348 57.2026 66.348 55.9622V43.9629L66.1703 44.1671C65.8014 44.591 65.3649 44.9507 64.8784 45.2318Lnan nanL64.8784 45.2318L63.4088 46.0808L60.4695 47.7789L56.5221 50.0594C55.3272 50.7497 53.8548 50.7497 52.6599 50.0594L48.7125 47.7789L45.7732 46.0808L44.3036 45.2318Lnan nanL44.3036 45.2318C43.8171 44.9507 43.3803 44.5913 43.0108 44.1679L42.834 43.9653L42.834 55.9622C42.834 57.2026 43.4955 58.3488 44.5696 58.9693Z",
    fill: "url(#paint7_linear_2137_19306)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5211 50.2997C55.3263 50.99 53.8539 50.9899 52.6591 50.2997L43.4497 44.9792C42.5923 44.4839 42.5923 43.2462 43.4497 42.7508L52.6589 37.4305C53.8538 36.7401 55.3263 36.7402 56.5212 37.4306L65.7305 42.7516C66.5879 43.247 66.5878 44.4847 65.7304 44.98L56.5211 50.2997Z",
    fill: "url(#paint8_linear_2137_19306)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3664 58.9693L23.1349 63.4573C24.5289 64.2626 26.2468 64.2626 27.6408 63.4573L35.4093 58.9693C36.4833 58.3488 37.1449 57.2026 37.1449 55.9622V43.9629L36.9672 44.1671C36.5983 44.591 36.1618 44.9507 35.6753 45.2318Lnan nanL35.6753 45.2318L34.2056 46.0808L31.2664 47.7789L27.319 50.0594C26.1241 50.7497 24.6516 50.7497 23.4568 50.0594L19.5094 47.7789L16.5701 46.0808L15.1005 45.2318Lnan nanL15.1005 45.2318C14.6139 44.9507 14.1771 44.5913 13.8077 44.1679L13.6309 43.9653L13.6309 55.9622C13.6309 57.2026 14.2924 58.3488 15.3664 58.9693Z",
    fill: "url(#paint9_linear_2137_19306)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.318 50.2997C26.1232 50.99 24.6508 50.9899 23.4559 50.2997L14.2466 44.9792C13.3892 44.4839 13.3892 43.2462 14.2466 42.7508L23.4557 37.4305C24.6507 36.7401 26.1232 36.7402 27.3181 37.4306L36.5274 42.7516C37.3848 43.247 37.3847 44.4847 36.5273 44.98L27.318 50.2997Z",
    fill: "url(#paint10_linear_2137_19306)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.0348,
    cy: 19.2901,
    rx: 3.29067,
    ry: 2.39947,
    fill: "#D9D9D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.0348,
    cy: 19.2901,
    rx: 3.29067,
    ry: 2.39947,
    fill: "url(#paint11_linear_2137_19306)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.5895,
    cy: 43.8648,
    rx: 3.29067,
    ry: 2.39947,
    fill: "#D9D9D9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.5895,
    cy: 43.8648,
    rx: 3.29067,
    ry: 2.39947,
    fill: "url(#paint12_linear_2137_19306)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.3864,
    cy: 43.8648,
    rx: 3.29067,
    ry: 2.39947,
    fill: "#D9D9D9"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.3864,
    cy: 43.8648,
    rx: 3.29067,
    ry: 2.39947,
    fill: "url(#paint13_linear_2137_19306)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7426 14.8758C46.339 12.897 42.0711 15.3526 42.0711 19.2896H38.2949C38.2949 12.4406 45.7194 8.16888 51.6405 11.6111L50.6916 13.2434L51.6405 11.6111L51.8469 11.7311C54.6242 13.3457 56.333 16.3157 56.333 19.5283V43.3865H52.5568V19.5283C52.5568 17.6608 51.5635 15.9343 49.949 14.9957L50.7962 13.5385L49.949 14.9957L49.7426 14.8758Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7426 14.8758C46.339 12.897 42.0711 15.3526 42.0711 19.2896H38.2949C38.2949 12.4406 45.7194 8.16888 51.6405 11.6111L50.6916 13.2434L51.6405 11.6111L51.8469 11.7311C54.6242 13.3457 56.333 16.3157 56.333 19.5283V43.3865H52.5568V19.5283C52.5568 17.6608 51.5635 15.9343 49.949 14.9957L50.7962 13.5385L49.949 14.9957L49.7426 14.8758Z",
    fill: "url(#paint14_linear_2137_19306)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19306",
    x1: 24.1047,
    y1: 26.6899,
    x2: 24.1047,
    y2: 46.7883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_19306",
    x1: 24.1038,
    y1: 19.6398,
    x2: 24.1038,
    y2: 33.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2137_19306",
    x1: 55.5969,
    y1: 26.3408,
    x2: 55.5969,
    y2: 46.4392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2137_19306",
    x1: 55.5959,
    y1: 19.2907,
    x2: 55.5959,
    y2: 33.1953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2137_19306",
    x1: 40.0383,
    y1: 35.1362,
    x2: 40.0383,
    y2: 55.2346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2137_19306",
    x1: 40.0383,
    y1: 19.3892,
    x2: 40.0383,
    y2: 39.4876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2137_19306",
    x1: 40.0373,
    y1: 12.339,
    x2: 40.0373,
    y2: 26.2437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2137_19306",
    x1: 54.591,
    y1: 43.9629,
    x2: 54.591,
    y2: 64.0613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2137_19306",
    x1: 54.5901,
    y1: 36.9128,
    x2: 54.5901,
    y2: 50.8174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2137_19306",
    x1: 25.3879,
    y1: 43.9629,
    x2: 25.3879,
    y2: 64.0613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2137_19306",
    x1: 25.387,
    y1: 36.9128,
    x2: 25.387,
    y2: 50.8174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2137_19306",
    x1: 40.0348,
    y1: 16.8906,
    x2: 40.0348,
    y2: 21.6896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2137_19306",
    x1: 54.5895,
    y1: 41.4653,
    x2: 54.5895,
    y2: 46.2643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2137_19306",
    x1: 25.3864,
    y1: 41.4653,
    x2: 25.3864,
    y2: 46.2643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2137_19306",
    x1: 47.314,
    y1: 10.3945,
    x2: 46.6418,
    y2: 43.3865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528456,
    stopColor: "#0D4D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#136ACE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsSolution2);
export default __webpack_public_path__ + "static/media/awsSolution2.71dcff9ddf9cc23607bf90c792049699.svg";
export { ForwardRef as ReactComponent };